import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './careers-saved-component.component.scss';
import axios from 'axios';
import * as $ from 'jquery';
var CareersSavedComponent = /** @class */ (function (_super) {
    tslib_1.__extends(CareersSavedComponent, _super);
    function CareersSavedComponent(element) {
        return _super.call(this, element) || this;
    }
    CareersSavedComponent.prototype.init = function () {
        var _this = this;
        if (this.element.getAttribute('data-site')) {
            this.dataSite = this.element.getAttribute('data-site');
        }
        else {
            this.dataSite = 'EXTERNAL';
        }
        if (this.element.getAttribute('data-language')) {
            this.dataLanguage = this.element.getAttribute('data-language');
        }
        else {
            this.dataLanguage = 'en-us';
        }
        if (this.element.getAttribute('data-limit')) {
            this.dataLimit = this.element.getAttribute('data-limit');
        }
        else {
            this.dataLimit = 10;
        }
        if (this.element.getAttribute('data-detail-url')) {
            this.dataDetail = this.element.getAttribute('data-detail-url');
        }
        else {
            this.dataDetail = "";
        }
        this.containerLoader = this.element.querySelector('.js-results-saved-loader');
        this.containerResults = this.element.querySelector('.js-results-saved');
        this.containerEmpty = this.element.querySelector('.js-empty-state');
        this.buttonClearFilters = Array.from(this.element.querySelectorAll('.js-clear-filters'));
        if (localStorage.getItem('sbgCareersSaved')) {
            this.storageCareers = localStorage.getItem('sbgCareersSaved');
        }
        else {
            this.storageCareers = JSON.stringify([]);
        }
        this.varSelected = false;
        this.urlGetJobs = "/sbutils/getJobsByID?";
        $(document).on('click', 'input.js-selected-jobs', function (e) {
            _this.detectCheckboxesSelected();
        });
        this.loadJobs();
    };
    CareersSavedComponent.prototype.bindEvents = function () {
        var _this = this;
        this.buttonClearFilters.map(function (button) { return button.addEventListener('click', function (e) {
            $('html,body').animate({
                scrollTop: 0
            }, 'slow');
            if (button.classList.contains('button--white')) {
                _this.removeAll();
            }
            else {
                _this.removeSelectedIds();
            }
        }); });
    };
    CareersSavedComponent.prototype.loadJobsEnOld = function () {
        // variables
        var containerLoader = this.containerLoader;
        var containerEmpty = this.containerEmpty;
        var containerResults = this.containerResults;
        var buttonClearFilters = this.buttonClearFilters;
        var json = JSON.parse(this.storageCareers);
        var IDs = '';
        for (var index = 0; index < json.length; index++) {
            var element = json[index];
            if (index === 0) {
                IDs += element;
            }
            else {
                IDs += '-' + element;
            }
        }
        // generate
        var detail = this.dataDetail;
        var site = this.dataSite;
        var language = this.dataLanguage;
        var limit = this.dataLimit;
        var offset = "0";
        // attributes
        var postData = '';
        if (site) {
            postData += 'site=' + site;
        }
        if (IDs) {
            postData += '&jobIDs=' + IDs;
        }
        postData += '&locale=' + language;
        postData += '&limit=' + limit;
        postData += '&offset=' + offset;
        // variables
        var urlGeneric = this.urlGetJobs + postData;
        // service
        axios.get(urlGeneric).then(function (response) {
            var json = response.data;
            var results = json.results;
            var output = "";
            if (json.total === 0) {
                containerLoader.classList.add('d-none');
                containerEmpty.classList.remove('d-none');
            }
            else {
                results.map(function (job) {
                    var date = new Date(job.datePosted).toLocaleDateString();
                    ;
                    output += "<div class=\"careers-saved-component__result\">\n\t\t\t\t\t\t<div class=\"careers-saved-component__result--title\">\n\t\t\t\t\t\t\t<div class=\"careers-saved-component__result--title__checkbox\">\t\n\t\t\t\t\t\t\t\t<label class=\"form__label filter-builder__form-field--checkboxlabel\">\n\t\t\t\t\t\t\t\t\t<div class=\"form__control\">\n\t\t\t\t\t\t\t\t\t\t<div class=\"form__control--checkbox\">\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t\t<input type=\"checkbox\" class=\"form__input js-selected-jobs\" value=\"" + job.jobPostId + "\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"form__control-indicator\"></div>\n\t\t\t\t\t\t\t\t\t\t</div>\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class=\"careers-saved-component__result--title__link\">\t\n\t\t\t\t\t\t\t\t<a href=\"" + detail + "?jobID=" + job.jobPostId + "&jobSite=" + site + "&jobLocale=" + job.locale + "\" target=\"_blank\" class=\"title title--module-title\">" + job.title + "</a>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"careers-saved-component__result--details\">\n\t\t\t\t\t\t\t<div class=\"careers-saved-component__result--details__location\">\n\t\t\t\t\t\t\t\t<strong>" + job.jobLocation[0].name + "</strong>\n\t\t\t\t\t\t\t</div>\t\n\t\t\t\t\t\t\t<div class=\"careers-saved-component__result--details__meta\">\n\t\t\t\t\t\t\t\t<div class=\"careers-saved-component__result--details__meta--dept\">\n\t\t\t\t\t\t\t\t\t<strong>Dept</strong>: " + job.FLD_JPM_BUSINESS_LINE + "\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=\"careers-saved-component__result--details__meta--type\">\n\t\t\t\t\t\t\t\t\t<strong>Job Type</strong>: " + job.employmentType + "\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=\"careers-saved-component__result--details__meta--date\">\n\t\t\t\t\t\t\t\t\t<strong>Date Posted</strong>: " + date + "\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\t\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"careers-saved-component__result--description\">\n\t\t\t\t\t\t\t" + job.description + "\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>";
                });
                buttonClearFilters.map(function (button) {
                    if (button.classList.contains('button--white')) {
                        var container = button.closest('.col-md-3');
                        container.classList.add('col-md-6');
                        container.classList.add('text-right');
                        container.classList.remove('d-none');
                        button.classList.remove('d-none');
                    }
                    else {
                        var container = button.closest('.col-md-3');
                        container.classList.add('d-none');
                    }
                });
                containerLoader.classList.add('d-none');
                containerResults.innerHTML = output;
                containerResults.classList.remove('d-none');
            }
        }).catch(function (error) {
            console.log(error);
            containerLoader.classList.add('d-none');
            containerEmpty.classList.remove('d-none');
        });
    };
    CareersSavedComponent.prototype.loadJobs = function () {
        var _this = this;
        // variables
        var containerLoader = this.containerLoader;
        var containerEmpty = this.containerEmpty;
        var containerResults = this.containerResults;
        var buttonClearFilters = this.buttonClearFilters;
        var loadJobsPt = this.loadJobsPt;
        var json = JSON.parse(this.storageCareers);
        var resultsNew = [];
        var IDs = '';
        for (var index = 0; index < json.length; index++) {
            var element = json[index];
            if (index === 0) {
                IDs += element;
            }
            else {
                IDs += '-' + element;
            }
        }
        // generate
        var detail = this.dataDetail;
        var site = this.dataSite;
        var language = 'en-us';
        var limit = this.dataLimit;
        var offset = "0";
        // attributes
        var postData = '';
        if (site) {
            postData += 'site=' + site;
        }
        if (IDs) {
            postData += '&jobIDs=' + IDs;
        }
        postData += '&locale=' + language;
        postData += '&limit=' + limit;
        postData += '&offset=' + offset;
        // date
        var todaysDate = new Date();
        var fullDate = todaysDate.getFullYear().toString() + todaysDate.getMonth().toString() + todaysDate.getDate().toString() + todaysDate.getHours().toString() + todaysDate.getMinutes().toString();
        postData += "&time=" + fullDate;
        // variables
        var urlGeneric = this.urlGetJobs + postData;
        var url = this.urlGetJobs;
        containerResults.innerHTML = "";
        // service
        axios.get(urlGeneric).then(function (response) {
            var json = response.data;
            var results = json.results;
            results.map(function (job) {
                var date = new Date(job.datePosted).toLocaleDateString();
                var output = "<div class=\"careers-saved-component__result\">\n\t\t\t\t\t<div class=\"careers-saved-component__result--title\">\n\t\t\t\t\t\t<div class=\"careers-saved-component__result--title__checkbox\">\t\n\t\t\t\t\t\t\t<label class=\"form__label filter-builder__form-field--checkboxlabel\">\n\t\t\t\t\t\t\t\t<div class=\"form__control\">\n\t\t\t\t\t\t\t\t\t<div class=\"form__control--checkbox\">\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t<input type=\"checkbox\" class=\"form__input js-selected-jobs\" value=\"" + job.jobPostId + "\">\n\t\t\t\t\t\t\t\t\t\t<div class=\"form__control-indicator\"></div>\n\t\t\t\t\t\t\t\t\t</div>\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"careers-saved-component__result--title__link\">\t\n\t\t\t\t\t\t\t<a href=\"" + detail + "?jobID=" + job.jobPostId + "&jobSite=" + site + "&jobLocale=" + job.locale + "\" target=\"_blank\" class=\"title title--module-title\" data-intent=\"navigational\" data-scope=\"careers-saved-component\" data-id=\"link_content\" data-text=\"Job Search | Results | " + job.title + " item click\">" + job.title + "</a>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"careers-saved-component__result--details\">\n\t\t\t\t\t\t<div class=\"careers-saved-component__result--details__location\">\n\t\t\t\t\t\t\t<strong>" + job.jobLocation[0].name + "</strong>\n\t\t\t\t\t\t</div>\t\n\t\t\t\t\t\t<div class=\"careers-saved-component__result--details__meta\">\n\t\t\t\t\t\t\t<div class=\"careers-saved-component__result--details__meta--dept\">\n\t\t\t\t\t\t\t\t<strong>Career Area</strong>: " + job.FLD_JPM_BUSINESS_LINE + "\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class=\"careers-saved-component__result--details__meta--type\">\n\t\t\t\t\t\t\t\t<strong>Job Type</strong>: " + job.employmentType + "\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\t\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"careers-saved-component__result--description\">\n\t\t\t\t\t\t" + job.description + "\n\t\t\t\t\t</div>\n\t\t\t\t</div>";
                var docFragment = document.createDocumentFragment();
                docFragment.appendChild(document.createRange().createContextualFragment(output));
                _this.containerResults.appendChild(docFragment);
            });
            loadJobsPt(containerLoader, containerEmpty, containerResults, buttonClearFilters, IDs, detail, site, limit, url);
        }).catch(function (error) {
            console.log(error);
            containerLoader.classList.add('d-none');
            containerEmpty.classList.remove('d-none');
        });
    };
    CareersSavedComponent.prototype.loadJobsPt = function (containerLoader, containerEmpty, containerResults, buttonClearFilters, IDs, detail, site, limit, url) {
        if (containerLoader === void 0) { containerLoader = undefined; }
        if (containerEmpty === void 0) { containerEmpty = undefined; }
        if (containerResults === void 0) { containerResults = undefined; }
        if (buttonClearFilters === void 0) { buttonClearFilters = undefined; }
        if (IDs === void 0) { IDs = ''; }
        if (detail === void 0) { detail = ""; }
        if (site === void 0) { site = ""; }
        if (limit === void 0) { limit = ""; }
        if (url === void 0) { url = ""; }
        // generate
        var language = 'pt';
        var offset = "0";
        // attributes
        var postData = '';
        if (site) {
            postData += 'site=' + site;
        }
        if (IDs) {
            postData += '&jobIDs=' + IDs;
        }
        postData += '&locale=' + language;
        postData += '&limit=' + limit;
        postData += '&offset=' + offset;
        // variables
        var urlGeneric = url + postData;
        // service
        axios.get(urlGeneric).then(function (response) {
            var json = response.data;
            var results = json.results;
            results.map(function (job) {
                var date = new Date(job.datePosted).toLocaleDateString();
                ;
                var output = "<div class=\"careers-saved-component__result\">\n\t\t\t\t\t<div class=\"careers-saved-component__result--title\">\n\t\t\t\t\t\t<div class=\"careers-saved-component__result--title__checkbox\">\t\n\t\t\t\t\t\t\t<label class=\"form__label filter-builder__form-field--checkboxlabel\">\n\t\t\t\t\t\t\t\t<div class=\"form__control\">\n\t\t\t\t\t\t\t\t\t<div class=\"form__control--checkbox\">\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t<input type=\"checkbox\" class=\"form__input js-selected-jobs\" value=\"" + job.jobPostId + "\">\n\t\t\t\t\t\t\t\t\t\t<div class=\"form__control-indicator\"></div>\n\t\t\t\t\t\t\t\t\t</div>\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"careers-saved-component__result--title__link\">\t\n\t\t\t\t\t\t\t<a href=\"" + detail + "?jobID=" + job.jobPostId + "&jobSite=" + site + "&jobLocale=" + job.locale + "\" target=\"_blank\" class=\"title title--module-title\">" + job.title + "</a>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"careers-saved-component__result--details\">\n\t\t\t\t\t\t<div class=\"careers-saved-component__result--details__location\">\n\t\t\t\t\t\t\t<strong>" + job.jobLocation[0].name + "</strong>\n\t\t\t\t\t\t</div>\t\n\t\t\t\t\t\t<div class=\"careers-saved-component__result--details__meta\">\n\t\t\t\t\t\t\t<div class=\"careers-saved-component__result--details__meta--dept\">\n\t\t\t\t\t\t\t\t<strong>Dept</strong>: " + job.FLD_JPM_BUSINESS_UNIT + "\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class=\"careers-saved-component__result--details__meta--type\">\n\t\t\t\t\t\t\t\t<strong>Job Type</strong>: " + job.employmentType + "\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class=\"careers-saved-component__result--details__meta--date\">\n\t\t\t\t\t\t\t\t<strong>Date Posted</strong>: " + date + "\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\t\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"careers-saved-component__result--description\">\n\t\t\t\t\t\t" + job.description + "\n\t\t\t\t\t</div>\n\t\t\t\t</div>";
                var docFragment = document.createDocumentFragment();
                docFragment.appendChild(document.createRange().createContextualFragment(output));
                containerResults.appendChild(docFragment);
            });
            if ($('div.careers-saved-component__result').length === 0) {
                containerLoader.classList.add('d-none');
                containerEmpty.classList.remove('d-none');
            }
            else {
                buttonClearFilters.map(function (button) {
                    if (button.classList.contains('button--white')) {
                        var container = button.closest('.col-md-3');
                        container.classList.add('col-md-6');
                        container.classList.add('text-right');
                        container.classList.remove('d-none');
                        button.classList.remove('d-none');
                    }
                    else {
                        var container = button.closest('.col-md-3');
                        container.classList.add('d-none');
                    }
                });
                containerLoader.classList.add('d-none');
                containerResults.classList.remove('d-none');
            }
        }).catch(function (error) {
            console.log(error);
            containerLoader.classList.add('d-none');
            containerEmpty.classList.remove('d-none');
        });
    };
    CareersSavedComponent.prototype.removeAll = function () {
        this.buttonClearFilters.map(function (button) {
            button.classList.add('d-none');
        });
        localStorage.removeItem('sbgCareersSaved');
        this.containerResults.classList.add('d-none');
        this.containerEmpty.classList.remove('d-none');
    };
    CareersSavedComponent.prototype.removeSelectedIds = function () {
        var storage = JSON.parse(this.storageCareers);
        var IDs = [];
        $('input.js-selected-jobs').each(function (index, item) {
            if ($(item).is(':checked')) {
                IDs.push($(item).val());
            }
        });
        for (var iStorage = 0; iStorage < storage.length; iStorage++) {
            for (var iLocal = 0; iLocal < IDs.length; iLocal++) {
                if (IDs[iLocal] === storage[iStorage]) {
                    storage.splice(iStorage, 1);
                }
            }
        }
        this.storageCareers = JSON.stringify(storage);
        this.buttonClearFilters.map(function (button) {
            var container = button.closest('.col-md-3');
            container.classList.add('d-none');
            button.classList.add('d-none');
        });
        this.containerLoader.classList.remove('d-none');
        this.containerResults.classList.add('d-none');
        localStorage.setItem('sbgCareersSaved', JSON.stringify(storage));
        this.loadJobs();
    };
    CareersSavedComponent.prototype.detectCheckboxesSelected = function () {
        var selected = false;
        $('input.js-selected-jobs').each(function (index, item) {
            if ($(item).is(':checked')) {
                selected = true;
            }
        });
        if (selected) {
            this.buttonClearFilters.map(function (button) {
                if (button.classList.contains('button--white')) {
                    var container = button.closest('.col-md-3');
                    container.classList.remove('col-md-6');
                    container.classList.remove('text-right');
                    button.classList.remove('d-none');
                }
                else {
                    var container = button.closest('.col-md-3');
                    container.classList.remove('d-none');
                    button.classList.remove('d-none');
                }
            });
        }
        else {
            this.buttonClearFilters.map(function (button) {
                if (button.classList.contains('button--white')) {
                    var container = button.closest('.col-md-3');
                    container.classList.add('col-md-6');
                    container.classList.add('text-right');
                    button.classList.remove('d-none');
                }
                else {
                    var container = button.closest('.col-md-3');
                    container.classList.add('d-none');
                    button.classList.add('d-none');
                }
            });
        }
    };
    return CareersSavedComponent;
}(Base));
export { CareersSavedComponent };



//////////////////
// WEBPACK FOOTER
// ./components/careers-saved-component/careers-saved-component.component.ts
// module id = 617
// module chunks = 0